export default __webpack_public_path__ + "static/media/ISEO CLASS-3 EXAM PATTERN 2026-27.c40a9c4a.pdf";